:host {
  display: block;
}

.#{$prefix}navigation-toolbar-wrapper {
  position: relative;
  width: 100%;
  height: 72px;
  background-color: $navigation-toolbar-bg-color;
  z-index: 91; // z-index is higher than other navigation components to prevent hiding of overlay/flyout components behind other navigation components

  .#{$prefix}navigation-toolbar-inner {
    position: relative;
    width: 100%;
    height: 100%;
    max-width: 1200px;
    margin: 0 auto 0 auto;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: stretch;
    z-index: 99;
  }
}
